const ALLOWLIST_ENV = new Set(['staging', 'dev', 'test']);

/**
 * Returns true if the current environment allows feature flag / experiment overrides.
 * Only staging, dev, and test environments are allowed — production is always blocked.
 */
export function isAllowedEnvironment(): boolean {
  try {
    if (!ALLOWLIST_ENV.has(process.env.VITE_CANVAS_ENV ?? '')) {
      return false;
    }

    if (process.env.VITE_CANVAS_ENV?.includes('prod')) {
      return false;
    }

    return true;
  } catch (e) {
    return false;
  }
}
